import styled from "styled-components";
import TextField from "@mui/material/TextField";
import { styled as MUIstyled } from "@mui/material/styles";
import theme from "../../../utils/theme";

const { colors, templateColors, fontSizes } = theme;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: calc(100vh - 80px);
  background-color: ${templateColors.lightGrey};
  padding: 8% 2% 4% 2%;
  font-family: "Inter", system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif;

  @media (max-width: 1224px) {
    padding-top: 18%;
  }
`;

export const Title = styled.h1`
  font-size: 36px;
  line-height: 1.15;
  font-weight: 700;
  color: ${templateColors.primaryBlack};
  text-align: center;
  margin: 0;

  @media (max-width: 1224px) {
    font-size: ${fontSizes.bigTitleMobile};
    padding-left: 5%;
    padding-right: 5%;
  }
`;

export const Subtitle = styled.p`
  font-size: ${fontSizes.subtitle};
  margin: 12px auto 0 auto;
  text-align: center;
  color: ${templateColors.primaryBlack};
  max-width: 600px;
  line-height: 1.4;

  @media (max-width: 1224px) {
    font-size: ${fontSizes.titleMobile};
    padding-left: 5%;
    padding-right: 5%;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 3%;
  width: 100%;
  max-width: 640px;

  @media (max-width: 1224px) {
    width: 90%;
    align-self: center;
  }
`;

export const CustomizedTextField = MUIstyled(TextField)`
  margin-top: 24px;
  background-color: ${templateColors.lightGrey};

  & .MuiInputLabel-formControl {
    color: ${templateColors.lightDark} !important;
  }

  & .MuiOutlinedInput-root {
    background: white;
    border-radius: 8px;

    & fieldset > legend {
      padding-right: 12px;
    }

    &.Mui-focused fieldset {
      border: 1px solid ${templateColors.lightDark};
    }

    &:hover .MuiOutlinedInput-notchedOutline {
      border: 1px solid ${templateColors.lightDark};
    }
  }

  & .MuiInputBase-root {
    color: ${templateColors.lightDark} !important;
  }

  & .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${templateColors.lightDark};
  }
` as typeof TextField;

export const ConsentRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 16px;
  padding-top: 8px;
  border-top: 1px solid #e5e7eb;
  color: ${templateColors.primaryBlack};

  input[type='checkbox'] {
    width: 18px;
    height: 18px;
    accent-color: ${templateColors.lightDark};
    cursor: pointer;
    margin-top: 4px;
  }

  label {
    font-size: 14px;
    line-height: 1.45;
    cursor: pointer;
  }
`;

export const SubmitButton = styled.button<{ disabled?: boolean }>`
  padding: 16px;
  font-size: ${fontSizes.subtitle};
  font-weight: 600;
  background-color: ${templateColors.lightDark};
  color: ${colors.white};
  border: none;
  border-radius: 8px;
  cursor: pointer;
  align-self: flex-end;
  margin-top: 26px;
  min-width: 220px;
  transition: opacity 0.15s ease, transform 0.02s ease;

  &:hover { opacity: 0.92; }
  &:active { transform: translateY(1px); }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.55;
  }
`;